import type { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import type { RouteLocationRaw } from 'vue-router';

export const ACTION_TOAST_GROUP = 'ui-action-toast';

const DEFAULT_ACTION_TOAST_LIFE_MS = 12_000;

export type ActionToastOptions = {
  summary: string;
  actionLabel: string;
  actionTo: RouteLocationRaw;
  detail?: string;
  severity?: ToastMessageOptions['severity'];
  life?: number;
};

export type ActionToastMessage = ToastMessageOptions & {
  actionLabel: string;
  actionTo: RouteLocationRaw;
};

export const useActionToast = () => {
  const toast = useToast();

  const showActionToast = ({
    summary,
    actionLabel,
    actionTo,
    detail,
    severity = 'info',
    life = DEFAULT_ACTION_TOAST_LIFE_MS,
  }: ActionToastOptions) => {
    const message: ActionToastMessage = {
      group: ACTION_TOAST_GROUP,
      severity,
      summary,
      detail,
      life,
      actionLabel,
      actionTo,
    };

    toast.add(message);
  };

  return { showActionToast };
};
